// @flow
import CentenaireSearch from 'components/centenaire/CentenaireSearch';
import { connect } from 'react-redux';

import type { StateType, DispatchType } from 'types/Actions';
import type { StateProps, DispatchProps } from 'components/centenaire/CentenaireSearch';

import { setQueryCentenaire } from 'actions/filterOptionsActions';

export default connect(
  (state: StateType): StateProps => ({
    userPref: state.userState.userPref
  }),
  (dispatch: DispatchType): DispatchProps => ({
    setQueryCentenaire: (queryCentenaire: string) => dispatch(setQueryCentenaire(queryCentenaire)),
  })
)(CentenaireSearch);
